import {
  BannerPromotionTile,
  BannerPromotionTileType,
  TileStatus,
} from '@varo/graphql-schema-types';
import { HomeCardDependencies } from 'features/home/HomeScreen/dependencies/types';
import { ProductOfferCardProps } from 'shared/components/vxl/cards/ProductOfferCard/ProductOfferCard';
import { IllustrationKeyType } from 'shared/components/vxl/Illustration/Illustration';
import { VXLComponent, VXLComponentId } from 'shared/renderer/types';
import theme from 'shared/styles/theme';
import { Maybe } from 'shared/utils/types';

interface BannerPromotionTilesNode extends VXLComponent {
  id: string;
  name: VXLComponentId.PRODUCT_OFFER_CARD;
  props: ProductOfferCardProps;
}

const getIllustrationKey = (
  tileType: BannerPromotionTileType,
): IllustrationKeyType => {
  switch (tileType) {
    case BannerPromotionTileType.VaroToAnyone:
      return 'PLANE_A';
    default:
      return 'PLANE_A';
  }
};

const getImageBackgroundColor = (tileType: BannerPromotionTileType) => {
  switch (tileType) {
    case BannerPromotionTileType.VaroToAnyone:
      return theme.color.expressive.light;
    default:
      return theme.color.expressive.light;
  }
};

const bannerPromotionTiles = (
  {
    id,
    status,
    heroText,
    contextText,
    bannerPromotionTileType,
  }: BannerPromotionTile,
  { bannerPromotionTileClicked }: HomeCardDependencies,
): Maybe<BannerPromotionTilesNode> => {
  if (status !== TileStatus.Loaded) {
    return null;
  }

  return {
    id: id,
    name: VXLComponentId.PRODUCT_OFFER_CARD,
    props: {
      titleText: heroText || '',
      buttonText: contextText,
      illustrationKey: getIllustrationKey(bannerPromotionTileType),
      illustrationBackgroundColor: getImageBackgroundColor(
        bannerPromotionTileType,
      ),
      onPress: () => {
        bannerPromotionTileClicked(bannerPromotionTileType);
      },
      analyticsId: 'v2aClicked',
    },
  };
};

export default bannerPromotionTiles;
